import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";
import CertificatesPageContent from "../components/certificates/certificates-page";

const CertificatesPage = () => {
  return (
    <Layout>
      <CertificatesPageContent />
    </Layout>
  );
};

export default CertificatesPage;

export const Head = () => <Seo title="Certificates" />;